import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/common/new_window_blue.svg'
import _imports_1 from '@/assets/images/common/arrow_right.svg'


const _withScopeId = n => (_pushScopeId("data-v-680c3e4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-form-input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact-form-description" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" お問い合わせはメール(年中無休)にて承っております。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" なお、お電話でのお問い合せは、営業時間内の対応となりますので、あらかじめご了承ください。 ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "TEL：050-3613-5193（10：00～18：00）※土日祝を除く"),
  /*#__PURE__*/_createElementVNode("p", { class: "annotation" }, " お申込後のお問い合わせは受注番号などの詳細をご記入ください。 ")
], -1))
const _hoisted_3 = { class: "block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "split-line" }, null, -1))
const _hoisted_5 = ["name", "value", "onChange"]
const _hoisted_6 = { class: "error-message" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/privacy",
  target: "_blank",
  class: "text-link"
}, [
  /*#__PURE__*/_createTextVNode(" 個人情報の取り扱いについて "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "open in new window"
  })
], -1))
const _hoisted_8 = { class: "form-check-out-block" }
const _hoisted_9 = {
  key: 0,
  class: "invalid-message"
}
const _hoisted_10 = {
  key: 1,
  class: "invalid-message"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow-right",
  src: _imports_1,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_large_heading = _resolveComponent("large-heading")!
  const _component_common_input = _resolveComponent("common-input")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_number_input = _resolveComponent("number-input")!
  const _component_pull_down_select = _resolveComponent("pull-down-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_in_case_check_box = _resolveComponent("in-case-check-box")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_large_heading, { title: "お問い合わせ" }),
    _createElementVNode("section", null, [
      _hoisted_2,
      _createVNode(_component_Form, {
        "validation-schema": _ctx.contentFormValidSchema,
        onInvalidSubmit: _ctx.onInvalidSubmit,
        onSubmit: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_input_field, {
              label: "お名前",
              "input-name": "inquiry_name",
              required: true,
              "pc-vertical": true
            }, {
              default: _withCtx(({ inputName }) => [
                _createVNode(_component_common_input, {
                  name: inputName,
                  modelValue: _ctx.formData.inquiry_name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.inquiry_name) = $event)),
                  class: "input",
                  placeholder: "田中 太郎"
                }, null, 8, ["name", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_input_field, {
              label: "会社名",
              "input-name": "inquiry_company_name",
              "pc-vertical": true
            }, {
              default: _withCtx(({ inputName }) => [
                _createVNode(_component_common_input, {
                  name: inputName,
                  modelValue: _ctx.formData.inquiry_company_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.inquiry_company_name) = $event)),
                  class: "input",
                  placeholder: "TORA株式会社"
                }, null, 8, ["name", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_input_field, {
              label: "メールアドレス",
              "input-name": "inquiry_email",
              required: true,
              "pc-vertical": true
            }, {
              default: _withCtx(({ inputName }) => [
                _createVNode(_component_common_input, {
                  name: inputName,
                  modelValue: _ctx.formData.inquiry_email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.inquiry_email) = $event)),
                  class: "input",
                  placeholder: "example@abcd.com"
                }, null, 8, ["name", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_input_field, {
              label: "電話番号",
              "input-name": "inquiry_tel",
              "pc-vertical": true
            }, {
              default: _withCtx(({ inputName }) => [
                _createVNode(_component_number_input, {
                  name: inputName,
                  modelValue: _ctx.formData.inquiry_tel,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.inquiry_tel) = $event)),
                  class: "input",
                  placeholder: "09012345678"
                }, null, 8, ["name", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_input_field, {
              label: "受注番号",
              "input-name": "inquiry_order_no",
              "pc-vertical": true
            }, {
              default: _withCtx(({ inputName }) => [
                _createVNode(_component_number_input, {
                  name: inputName,
                  modelValue: _ctx.formData.inquiry_order_no,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.inquiry_order_no) = $event)),
                  class: "input",
                  placeholder: "1234567"
                }, null, 8, ["name", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_input_field, {
              label: "お問い合わせ項目",
              "input-name": "inquiry_type",
              required: true,
              "pc-vertical": true
            }, {
              default: _withCtx(({ inputName }) => [
                _createVNode(_component_pull_down_select, {
                  name: inputName,
                  modelValue: _ctx.formData.inquiry_type,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.inquiry_type) = $event)),
                  options: _ctx.contactReasonOptions,
                  class: "input"
                }, null, 8, ["name", "modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_input_field, {
              label: "お問い合わせ内容",
              "input-name": "inquiry_content",
              required: true,
              "pc-vertical": true
            }, {
              default: _withCtx(({ inputName }) => [
                _createVNode(_component_Field, {
                  modelValue: _ctx.formData.inquiry_content,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.inquiry_content) = $event)),
                  name: inputName
                }, {
                  default: _withCtx(({ field, handleChange, errors, errorMessage }) => [
                    _createElementVNode("textarea", {
                      rows: "10",
                      name: inputName,
                      value: field.value,
                      class: _normalizeClass(["common-input textarea", { invalid: errorMessage }]),
                      placeholder: "お問い合わせ内容をご記入ください",
                      onChange: handleChange
                    }, null, 42, _hoisted_5),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(errors[0]), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "name"])
              ]),
              _: 1
            }),
            _createVNode(_component_in_case_check_box, {
              name: "privacy_policy_agreement",
              modelValue: _ctx.privacyPolicyChecked,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.privacyPolicyChecked) = $event)),
              style: {"background":"#fff9f1"}
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" に同意する ")
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.formData.inquiry_token)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, " 申し訳ありません、システム上の問題により質問を送信することができません "))
              : (!_ctx.privacyPolicyChecked)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, " 個人情報の取り扱いについてをご確認の上チェックをしてください "))
                : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: _normalizeClass(["forward", { disabled: !_ctx.privacyPolicyChecked }]),
              disabled: !_ctx.privacyPolicyChecked
            }, [
              _createTextVNode(" 入力内容の確認 "),
              _hoisted_12
            ], 10, _hoisted_11)
          ])
        ]),
        _: 1
      }, 8, ["validation-schema", "onInvalidSubmit", "onSubmit"])
    ])
  ]))
}